import copies from '../../../copies.json';

type EditBriefCopies = typeof copies.ai_brief.edit_brief;

export type SectionGroup = Pick<EditBriefCopies, 'recommended_sections' | 'attachments'>;

export const DEFAULT_SECTIONS_GROUP: keyof SectionGroup = 'recommended_sections';
